import { call, put, takeEvery } from 'redux-saga/effects';

import { ContentActionNotification } from '~commonInfra/contentActions/ContentActionNotification';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Messages } from '../../../codegen/Localize';
import { DataSources } from '../../../datasource/resources/Datasources';
import { EXTRACT_FAILURE_NOTIFICATION_OPT_IN_FAILURE, EXTRACT_FAILURE_NOTIFICATION_OPT_IN_REQUEST,
     EXTRACT_FAILURE_NOTIFICATION_OPT_IN_SUCCESS, EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_FAILURE, EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_REQUEST,
    EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_SUCCESS, ExtractFailureNotificationAction
} from '../../../extractTask/actions/ExtractFailureNotificationActions';

function checkForErrors(response: IResult) {
    return response && response.errors && response.errors.length > 0;
}

export interface ExtractFailureNotificationToastConfig {
    apiCall: (id: string, contentType: string) => Promise<IResult>;
    successType: string;
    failureType: string;
    successMessage: () => string;
    failureMessage: () => string;
}

export const responseError: Error = new Error('Extract Falure Notification OptIn or OptOut API returned failure.');

export const optInConfig: ExtractFailureNotificationToastConfig = {
    apiCall: DataSources.enableFailureNotification,
    successType: EXTRACT_FAILURE_NOTIFICATION_OPT_IN_SUCCESS,
    failureType: EXTRACT_FAILURE_NOTIFICATION_OPT_IN_FAILURE,
    successMessage: Messages.extractFailureNotificationOptedIn,
    failureMessage: Messages.extractFailureNotificationOptInFailed
};

export const optOutConfig: ExtractFailureNotificationToastConfig = {
    apiCall: DataSources.disableFailureNotification,
    successType: EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_SUCCESS,
    failureType: EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_FAILURE,
    successMessage: Messages.extractFailureNotificationOptedOut,
    failureMessage: Messages.extractFailureNotificationOptOutFailed
};

export function* handleNotificationChange(action: ExtractFailureNotificationAction, config: ExtractFailureNotificationToastConfig): Generator {
    try {
      const response = yield call(config.apiCall, action.id, action.contentType);
      if (checkForErrors(response)) {
        throw responseError;
      }
      yield put({ type: config.successType, id: action.id });
      ContentActionNotification.displaySuccessToast(config.successMessage());
    } catch (error) {
      yield put({ type: config.failureType, error: error });
      ContentActionNotification.displayFailureToast(config.failureMessage());
    }
}

export function* handleOptIn(action: ExtractFailureNotificationAction): Generator {
    yield call(handleNotificationChange, action, optInConfig);
}

export function* handleOptOut(action: ExtractFailureNotificationAction): Generator {
    yield call(handleNotificationChange, action, optOutConfig);
}

export function* watchExtractFailureNotificationActions() {
    yield takeEvery(EXTRACT_FAILURE_NOTIFICATION_OPT_IN_REQUEST, handleOptIn);
    yield takeEvery(EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_REQUEST, handleOptOut);
}
